export const GET_PRODUCTS_REQUEST = "PRODUCT.GET_PRODUCTS_REQUEST";
export const GET_PRODUCTS_SUCCESS = "PRODUCT.GET_PRODUCTS_SUCCESS";
export const GET_PRODUCTS_FAILURE = "PRODUCT.GET_PRODUCTS_FAILURE";

export const GET_SINGLE_PRODUCT_REQUEST = "PRODUCT.GET_SINGLE_PRODUCT_REQUEST";
export const GET_SINGLE_PRODUCT_SUCCESS = "PRODUCT.GET_SINGLE_PRODUCT_SUCCESS";
export const GET_SINGLE_PRODUCT_FAILURE = "PRODUCT.GET_SINGLE_PRODUCT_FAILURE";

export const GET_MAIN_CATEGORY_REQUEST = "PRODUCT.GET_MAIN_CATEGORY_REQUEST";
export const GET_MAIN_CATEGORY_SUCCESS = "PRODUCT.GET_MAIN_CATEGORY_SUCCESS";
export const GET_MAIN_CATEGORY_FAILURE = "PRODUCT.GET_MAIN_CATEGORY_FAILURE";

export const GET_SUB_CATEGORY_REQUEST = "PRODUCT.GET_SUB_CATEGORY_REQUEST";
export const GET_SUB_CATEGORY_SUCCESS = "PRODUCT.GET_SUB_CATEGORY_SUCCESS";
export const GET_SUB_CATEGORY_FAILURE = "PRODUCT.GET_SUB_CATEGORY_FAILURE";

export const CREATE_REVIEW_REQUEST = "PRODUCT.CREATE_REVIEW_REQUEST";
export const CREATE_REVIEW_SUCCESS = "PRODUCT.CREATE_REVIEW_SUCCESS";
export const CREATE_REVIEW_FAILURE = "PRODUCT.CREATE_REVIEW_FAILURE";

export const CREATE_PRODUCT_REQUEST = "PRODUCT.CREATE_PRODUCT_REQUEST";
export const CREATE_PRODUCT_SUCCESS = "PRODUCT.CREATE_PRODUCT_SUCCESS";
export const CREATE_PRODUCT_FAILURE = "PRODUCT.CREATE_PRODUCT_FAILURE";

export const SET_SELECTED_CATEGORY = "PRODUCT.SET_SELECTED_CATEGORY";

export const GET_ALL_SUB_CATEGORIES_REQUEST =
  "PRODUCT.GET_ALL_SUB_CATEGORIES_REQUEST";
export const GET_ALL_SUB_CATEGORIES_SUCCESS =
  "PRODUCT.GET_ALL_SUB_CATEGORIES_SUCCESS";
export const GET_ALL_SUB_CATEGORIES_FAILURE =
  "PRODUCT.GET_ALL_SUB_CATEGORIES_FAILURE";
